'use client';
import { createStyles } from '@s7/styles';
import { buttonStylesReset } from '../utils/resetStyles/UnstyledButton.reset.js';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var useStyles = createStyles(function() {
    return {
        root: _extends({}, buttonStylesReset),
        wrapper: {
            cursor: "not-allowed",
            display: "block",
            "&[data-stretch=true]": {
                display: "inline"
            },
            width: "fit-content"
        }
    };
});

export { useStyles as default };
